import { Grid, Headline, rem, SpaceBetween, spacing, styled, useTranslation } from '@lessonup/ui-components';
import React from 'react';
import { i18nextNamespace } from '../../utils/consts';
import { Report, ReportLesson } from '../../utils/types';
import { QuestionsListCard } from '../QuestionsListCard/QuestionsListCard';
import { ReportPageExplanationBanner } from '../ReportPageExplanationBanner/ReportPageExplanationBanner';
import { StudentListCard } from '../StudentListCard/StudentListCard';
import { SummaryCard } from '../SummaryCard/SummaryCard';

export interface ReportDetailsProps {
  report: Omit<Report, 'lesson'> & { lesson: Pick<ReportLesson, 'name'> };
  exportButton?: React.JSX.Element;
}

export const ReportDetails: React.FC<ReportDetailsProps> = ({ report, exportButton }) => {
  const { t } = useTranslation(i18nextNamespace, { keyPrefix: 'detailsPage' });
  return (
    <FullHeightWrapper>
      <FullHeightSpaceBetween direction="y" spacing={spacing.size16}>
        <Headline size="small">{t('pageTitle')}</Headline>
        <ReportPageExplanationBanner />
        <ReportsContainer>
          <ReportsWrapper cols={2} gap={spacing.size16} justifyItems="stretch" alignItems="stretch">
            <LeftGroup direction="y" spacing={spacing.size16}>
              <SummaryCard report={report} />
              <StyledStudentListCard students={report.studentReports} />
            </LeftGroup>
            <RightGroup direction="y" spacing={spacing.size16}>
              <StyledQuestionsListCard questions={report.questionReports} exportButton={exportButton} />
            </RightGroup>
          </ReportsWrapper>
        </ReportsContainer>
      </FullHeightSpaceBetween>
    </FullHeightWrapper>
  );
};

const FullHeightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ReportsContainer = styled.div`
  position: relative;
  flex-grow: 1;
  min-height: 0;
  height: 100%;
`;

const ReportsWrapper = styled(Grid)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  grid-template-columns: ${rem('320px')} 1fr;
  grid-template-rows: 1fr;
`;

const LeftGroup = styled(SpaceBetween)`
  height: 100%;
  overflow: auto;
  align-items: flex-start;
`;

const RightGroup = styled(SpaceBetween)`
  height: 100%;
  overflow: auto;
`;

const StyledStudentListCard = styled(StudentListCard)`
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const StyledQuestionsListCard = styled(QuestionsListCard)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 0;
`;

const FullHeightSpaceBetween = styled(SpaceBetween)`
  flex-grow: 1;
  min-height: 0;
`;
